"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apolloCache = void 0;
const cache_1 = require("@apollo/client/cache");
exports.apolloCache = new cache_1.InMemoryCache({
    possibleTypes: {
        IngredientOrHeader: ["Ingredient", "IngredientHeader"],
    },
    typePolicies: {
        Query: {
            fields: {
                getRecipeById(_, { args, toReference }) {
                    return toReference({
                        __typename: "Recipe",
                        id: args === null || args === void 0 ? void 0 : args.id,
                    });
                },
                getCookbookById(_, { args, toReference }) {
                    return toReference({
                        __typename: "Cookbook",
                        id: args === null || args === void 0 ? void 0 : args.id,
                    });
                },
                getSectionById(_, { args, toReference }) {
                    return toReference({
                        __typename: "Section",
                        id: args === null || args === void 0 ? void 0 : args.id,
                    });
                },
            },
        },
    },
});
//# sourceMappingURL=apolloCache.js.map